import React, { Fragment } from "react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";

import ChevronDown from "../../../autorizaciones/UI/ChevronDown";
import { CotizacionItem } from "./CotizacionItem";

export const MesaEntradaAccordionCotizaciones = (props) => {
  const { cotizaciones } = props;

  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">Cotizaciones Aceptadas</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {Array.isArray(cotizaciones) && cotizaciones?.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ width: "10%" }}>Estado</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>N° Orden</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Fecha Aceptacion</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Afiliado</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>N° Afiliado</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Fecha Cirugia</TableCell>
                <TableCell align="center" style={{ width: "20%" }}></TableCell>
                <TableCell align="center" style={{ width: "20%" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cotizaciones.map((cotizacion, index) => {
                return (
                  <Fragment key={index}>
                    <CotizacionItem cotizacion={cotizacion} />
                  </Fragment>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
            No hay Cotizaciones
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
